<template>
	<div :id="name">
		<div class="action-part">
			<el-form :inline="true" size="medium">
				<el-form-item>
					<el-button type="primary" @click="showEditor(null)">创建教材</el-button>
				</el-form-item>
				<el-form-item>
					<el-input v-model="search.name" placeholder="请输入教材名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="doSearch">查 询</el-button>
					<el-button type="info" @click="doSearchCancel">重 置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="content-list">
			<el-table border :data="resultList" style="width: 100%">
				<el-table-column width="150" align="center" label="封面">
					<template slot-scope="scope">
						<img :src="scope.row.cover" style="border-radius: 5px; width: 63px; height: 83px" />
					</template>
				</el-table-column>
				<el-table-column prop="name" label="教材名称" width="250"> </el-table-column>
				<el-table-column min-width="200" prop="description" label="简介" class-name="description-cell">
					<template v-slot="scope">
						<div class="description-container">
							<el-tooltip :content="scope.row.description" placement="top">
								<span>{{ scope.row.description }}</span>
							</el-tooltip>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="ord" label="排序" align="center" width="180"> </el-table-column>
				<el-table-column prop="moduleName" label="所属模块名" align="center" width="180"> </el-table-column>
				<el-table-column width="180" align="center" label="是否可用">
					<template slot-scope="scope">
						<el-switch
							v-model="scope.row.enable"
							active-value="1"
							inactive-value="0"
							@change="onItemEnableChange(scope.row)"
						></el-switch>
					</template>
				</el-table-column>
				<el-table-column prop="viewCount" width="180" align="center" label="浏览量"> </el-table-column>
				<el-table-column prop="groupCount" width="180" align="center" label="识字组数量"> </el-table-column>
				<el-table-column width="180" align="center" label="消耗石头">
					<template slot-scope="scope">
						<span style="color: green" v-if="scope.row.payWith === '1'">{{ scope.row.price }} (绿色石头)</span>
						<span style="color: blue" v-if="scope.row.payWith === '2'">{{ scope.row.price }} (蓝色石头)</span>
						<span style="color: red" v-if="scope.row.payWith === '3'">{{ scope.row.price }} (红色石头)</span>
						<span style="color: #fafa03" v-if="scope.row.payWith === '4'">{{ scope.row.price }} (黄色石头)</span>
						<span style="color: #4ec9b0" v-if="scope.row.payWith === '5'">{{ scope.row.price }} (青色石头)</span>
						<span style="color: orange" v-if="scope.row.payWith === '6'">{{ scope.row.price }} (橙色石头)</span>
						<span style="color: #5c2699" v-if="scope.row.payWith === '7'">{{ scope.row.price }} (紫色石头)</span>
						<span v-if="scope.row.payWith === null || scope.row.payWith === '0'">免费</span>
					</template>
				</el-table-column>
				<el-table-column prop="wordCount" width="180" align="center" label="识字数量"> </el-table-column>
				<el-table-column prop="createTime" width="180" label="创建时间"> </el-table-column>
				<el-table-column align="center" width="300" label="操作">
					<template slot-scope="scope">
						<el-button type="info" size="medium" @click="toBookPage(scope.row)">详情</el-button>
						<el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
						<el-popconfirm
							confirm-button-text="马上删除"
							cancel-button-text="我后悔了"
							icon="el-icon-info"
							@confirm="deleteItem(scope.row)"
							icon-color="red"
							title="确定删除该教材吗？"
						>
							<el-button slot="reference" type="danger" style="margin-left: 10px" size="medium"> 删除 </el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page-part">
			<el-pagination
				size="small"
				background
				@current-change="loadByPage"
				:page-size="pagination.pageSize"
				:current-page="pagination.currentPage"
				layout="prev, pager, next"
				:total="pagination.total"
			>
			</el-pagination>
		</div>
		<div class="dialog-part">
			<el-dialog
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				:title="editorTitle"
				:visible.sync="isEditorShow"
				width="500px"
				center
			>
				<div class="dialog-content">
					<el-form label-width="80px" size="medium">
						<el-form-item label="模块" :required="true">
							<el-cascader
								clearable
								v-model="selectModuleIds"
								:options="appModuleTreeData"
								:props="{ checkStrictly: false, value: 'id', label: 'name' }"
								:show-all-levels="false"
								@change="handleChange"
								placeholder="请选择数据的模块"
							></el-cascader>
						</el-form-item>
						<el-form-item label="名称" :required="true">
							<el-input type="text" maxlength="8" show-word-limit v-model="book.name"></el-input>
						</el-form-item>
						<el-form-item label="简介" :required="true">
							<el-input
								v-model="book.description"
								type="textarea"
								:show-word-limit="true"
								:maxlength="100"
								resize="none"
								rows="4"
							></el-input>
						</el-form-item>
						<el-form-item label="封面" :required="true">
							<div class="form-item-container">
								<!-- <div class="image-upload-cover" @click="showImageCut">
									<img v-if="book.cover" :src="book.cover" class="avatar" />
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</div> -->
								<el-upload
									class="avatar-uploader"
									:action="`${apiBaseUrl}/md/image/book-cover?ct-sob-admin-token=${token}`"
									:headers="uploadHeaders"
									:show-file-list="false"
									name="image"
									:before-upload="beforeAvatarUpload"
									:on-success="handleAvatarSuccess"
									:on-error="handleAvatarError"
									:on-progress="handleAvatarProgress"
								>
									<!-- 上传中状态 -->
									<div v-if="uploadLoading" class="avatar-uploader">
										<el-progress type="circle" :percentage="uploadProgress" :width="80" :stroke-width="4"></el-progress>
										<div class="upload-text">上传中...</div>
									</div>
									<!-- 已上传图片 -->
									<div v-else-if="book.cover" class="avatar-container">
										<el-image fit="cover" :src="book.cover" class="avatar" />
										<div class="avatar-actions">
											<i class="el-icon-view eye-icon" @click.stop="previewImage(book.cover)"></i>
											<i class="el-icon-delete delete-icon" @click.stop="removeImage"></i>
										</div>
									</div>

									<!-- 未上传状态 -->
									<div v-else class="upload-placeholder">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</div>
								</el-upload>
							</div>
							<div class="form-des-text">支持JPEG/PNG，大小不超过2M，尺寸大小为：1260x1660</div>
						</el-form-item>
						<el-form-item label="石头" :required="true">
							<el-select v-model="book.payWith">
								<el-option value="0" label="免费"></el-option>
								<el-option value="1" label="绿色石头"></el-option>
								<el-option value="2" label="蓝色石头"></el-option>
								<el-option value="3" label="红色石头"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="单价" :required="true" v-if="book.payWith !== null && book.payWith !== '0'">
							<el-input-number v-model="book.price" :min="1"></el-input-number>
						</el-form-item>
						<el-form-item label="排序" :required="true">
							<el-input-number v-model="book.ord" :min="0"></el-input-number>
						</el-form-item>
						<!--						<el-form-item label="状态" :required="true">-->
						<!--							<el-switch active-value="1" inactive-value="0" v-model="book.enable"></el-switch>-->
						<!--						</el-form-item>-->
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="onEditorCancel">取 消</el-button>
					<el-button type="primary" @click="onEditorConfirm">确 定</el-button>
				</span>
			</el-dialog>

			<!-- <my-upload
				ref="imageUpload"
				field="image"
				@crop-upload-success="cropUploadSuccess"
				v-model="isCutShow"
				:withCredentials="true"
				:noCircle="true"
				:url="imageUploadUrl"
				img-format="jpg"
			></my-upload> -->
			<!-- 图片预览 -->
			<el-dialog :visible.sync="previewVisible">
				<img width="100%" :src="previewImageUrl" alt="" />
			</el-dialog>
		</div>
	</div>
</template>
<script>
import * as api from "../../api/api";
// import myUpload from "vue-image-crop-upload";

export default {
	components: {
		// myUpload,
	},
	data() {
		return {
			name: "book",
			pagination: {
				pageSize: 1,
				total: 0,
				currentPage: 1,
				totalPage: 1,
			},
			search: {
				name: "",
			},
			book: {
				id: "",
				name: "",
				cover: "",
				ord: 0,
				enable: "1",
				description: "",
				payWith: "0",
				price: 0,
				moduleId: "0",
			},
			selectModuleIds: [],
			appModuleTreeData: [],
			editorTitle: "",
			isEditorShow: false,
			imageUploadUrl: "",
			isCutShow: false,
			uploadHeaders: {},
			resultList: [],
			// 上传相关状态
			uploadLoading: false,
			uploadProgress: 0,
			uploadTimer: null,
			// 图片预览相关
			previewVisible: false,
			previewImageUrl: "",
			// API基础URL和token
			apiBaseUrl: api.baseUrl,
			token: this.$store?.state?.user?.token || "",
		};
	},
	methods: {
		onItemEnableChange(item) {
			api.putBook(item).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.$message.success("更新状态成功.");
				} else {
					this.$message.error("更新状态失败.");
				}
			});
		},
		getModuleTreeData() {
			api.getAppModuleTree().then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.appModuleTreeData = result.data;
				}
			});
		},
		deleteItem(item) {
			api.deleteBook(item.id).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					this.$message.success(result.msg);
					this.listContent();
				} else {
					this.$message.error(result.msg);
				}
			});
		},
		toBookPage(item) {
			this.$router.push({
				path: "/word/book-detail",
				query: {
					bookId: item.id,
				},
			});
		},
		cropUploadSuccess(result) {
			if (result.code === api.SUCCESS_CODE) {
				this.book.cover = result.data;
			}
		},
		showImageCut() {
			this.isCutShow = true;
			const token = this.$store.state.user.token;
			this.imageUploadUrl = `${api.baseUrl}/md/image/book-cover?ct-sob-admin-token=${token}`;
		},
		// 上传前的验证
		beforeAvatarUpload(file) {
			const isJPG = file.type === "image/jpeg" || file.type === "image/jpg";
			const isPNG = file.type === "image/png";
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isJPG && !isPNG) {
				this.$message.error("封面图片只能是 JPG/PNG 格式!");
				return false;
			}
			if (!isLt2M) {
				this.$message.error("封面图片大小不能超过 2MB!");
				return false;
			}

			// 设置上传URL和headers
			const token = this.$store.state.user.token;
			this.imageUploadUrl = `${api.baseUrl}/md/image/book-cover?ct-sob-admin-token=${token}`;
			this.uploadHeaders = {
				"ct-sob-admin-token": token,
			};

			return true;
		},

		// 上传成功处理
		handleAvatarSuccess(response) {
			this.uploadLoading = false;
			this.uploadProgress = 0;
			if (response.code === api.SUCCESS_CODE) {
				this.book.cover = response.data;
				this.$message.success("封面上传成功");
			} else {
				this.$message.error(response.msg || "封面上传失败");
			}
		},

		// 上传失败处理
		handleAvatarError(error) {
			console.error("上传失败:", error);
			this.$message.error("封面上传失败，请重试");
			this.uploadLoading = false;
			this.uploadProgress = 0;
		},
		// 上传进度处理
		handleAvatarProgress(event) {
			this.uploadLoading = true;
			this.uploadProgress = Math.round((event.loaded / event.total) * 100);
		},
		handlePreview(file) {
			this.previewImageUrl = file.url;
			this.previewVisible = true;
		},
		previewImage(url) {
			this.previewImageUrl = url;
			this.previewVisible = true;
		},
		removeImage() {
			this.book.cover = "";
			this.uploadLoading = false;
			this.uploadProgress = 0;
		},
		onEditorCancel() {
			this.book.id = "";
			this.book.name = "";
			this.book.cover = "";
			this.book.description = "";
			this.book.ord = 0;
			this.book.enable = "1";
			this.book.price = 0;
			this.book.payWith = "0";
			this.book.moduleId = "0";
			this.isEditorShow = false;
		},
		onEditorConfirm() {
			//检查数据
			if (this.book.name === "") {
				return this.$message.error("教材名称不可以为空.");
			}
			if (this.book.description === "") {
				return this.$message.error("教材简介不可以为空.");
			}
			if (this.book.description.length > 128) {
				return this.$message.error("教材简介最多128个字符.");
			}
			if (this.book.cover === "") {
				return this.$message.error("请上传教材封面.");
			}
			if (this.book.payWith === "0") {
				this.book.price = 0;
			} else if (this.book.price === 0) {
				this.book.payWith = "0";
			}

			if (this.selectModuleIds[this.selectModuleIds.length - 1]) {
				this.book.moduleId = this.selectModuleIds[this.selectModuleIds.length - 1];
			}
			if (this.book.id === "") {
				api.postBook(this.book).then((result) => {
					if (result.code === api.SUCCESS_CODE) {
						this.$message.success(result.msg);
						this.$router.push({
							path: "/word/book-detail",
							query: {
								bookId: result.data,
							},
						});
						this.onEditorCancel();
					} else {
						this.$message.error(result.msg);
					}
				});
			} else {
				//走更新的流程
				api.putBook(this.book).then((result) => {
					if (result.code === api.SUCCESS_CODE) {
						this.$message.success(result.msg);
						this.listContent();
						this.onEditorCancel();
					} else {
						this.$message.error(result.msg);
					}
				});
			}
		},
		doSearch() {
			this.pagination.currentPage = 1;
			this.listContent();
		},

		findPath(tree, targetId, path = []) {
			for (let node of tree) {
				const currentPath = [...path, node.id];
				if (node.id === targetId) {
					return currentPath;
				}
				if (node.children && node.children.length > 0) {
					const result = this.findPath(node.children, targetId, currentPath);
					if (result) return result;
				}
			}
			return null;
		},

		async showEditor(item) {
			console.log(item);
			this.selectModuleIds = [];

			// 定义一个函数用于回填模块路径
			const setModulePath = () => {
				if (item) {
					this.book.id = item.id;
					this.book.name = item.name;
					this.book.cover = item.cover;
					this.book.payWith = item.payWith;
					this.book.price = item.price;
					this.book.ord = item.ord;
					this.book.enable = item.enable;
					this.book.description = item.description;
					this.book.moduleId = String(item.moduleId);
					let path = this.findPath(this.appModuleTreeData, item.moduleId);
					this.selectModuleIds = path || []; // 如果找到就赋值，否则空数组
					this.editorTitle = "编辑教材";
				} else {
					this.editorTitle = "创建教材";
					this.selectModuleIds = []; // 创建新教材时，模块路径为空
				}
				this.isEditorShow = true;
			};

			// 如果模块树数据不存在，则先加载
			if (this.appModuleTreeData.length === 0) {
				api.getAppModuleTree().then((result) => {
					if (result.code === api.SUCCESS_CODE) {
						this.appModuleTreeData = result.data;
						// 数据加载完成后，再设置模块路径
						setModulePath();
					}
				});
			} else {
				// 如果已有数据，直接设置
				setModulePath();
			}
		},
		doSearchCancel() {
			this.search.name = "";
			this.doSearch();
		},
		loadByPage(page) {
			this.pagination.currentPage = page;
			this.listContent();
		},
		listContent() {
			api.listBook(this.pagination.currentPage, this.search.name).then((result) => {
				if (result.code === api.SUCCESS_CODE) {
					let data = result.data;
					this.resultList = data.list;
					this.pagination.currentPage = data.currentPage;
					this.pagination.pageSize = data.pageSize;
					this.pagination.total = data.total;
					this.pagination.totalPage = data.totalPage;
				}
			});
		},
		handleChange(value) {
			console.log(value);
		},
	},
	mounted() {
		console.log(this.token);
		this.listContent();
		this.getModuleTreeData();
	},
};
</script>
<style>
.image-upload-cover {
	width: 90px;
	height: 120px;
}

.image-upload-cover img {
	width: 100%;
	border-radius: 4px;
	height: 100%;
}

.form-des-text {
	font-size: 13px;
	color: #9d9d9d;
}
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 120px;
	height: 120px;
	line-height: 120px;
	text-align: center;
}
.avatar {
	width: 120px;
	height: 120px;
	display: block;
}
/* 已上传图片容器样式 */
.avatar-container {
	position: relative;
	width: 100%;
	height: 100%;
}

.avatar-container:hover .avatar-actions {
	opacity: 1;
}

.avatar-actions {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 15px;
	opacity: 0;
	transition: opacity 0.3s;
}

.eye-icon,
.delete-icon {
	color: white;
	font-size: 18px;
	cursor: pointer;
	transition: all 0.3s;
}

.eye-icon:hover {
	color: #409eff;
	transform: scale(1.2);
}

.delete-icon:hover {
	color: #f56c6c;
	transform: scale(1.2);
}
</style>
